<i [class]="icon"></i>
<ng-content></ng-content>
